import { Model } from 'ngx-super-model';

import { UserInfoDTO } from '../interfaces/user-info.dto';

export class UserInfo extends Model<UserInfoDTO> {
  firstName = '';
  lastName = '';
  phone: string | null = null;
  mobile: string | null = null;
  photo: string | null = null;
  created: string | null = null;
  createdBy: string | null = null;
  deletedAt: string | null = null;
  updated: string | null = null;
  updatedBy: string | null = null;
}
